import { type FC, useContext } from "react";
import { OUTPUT_NAV_NAME } from "@legacy_user_frontend/components/pages/jobs/job_search_navigation";
import { ModalContext } from "@legacy_user_frontend/components/pages/jobs/job_search_navigation/src/modules";
import * as styles from "./src/styles.css";

type SearchNavigationProps = {
  navListGroup: {
    key: string;
    value: {
      [key: string]: string | number | boolean;
      /* 定義しないと代入箇所で怒られるものは個別に定義 */
      id: number;
      search_path: string; // eslint-disable-line camelcase
      is_number_displayed: boolean; // eslint-disable-line camelcase
    }[];
  };
  gaAction: string;
  moreSearchButtonDisplayed: boolean;
};

export const SearchNavigation: FC<SearchNavigationProps> = ({
  navListGroup,
  gaAction,
  moreSearchButtonDisplayed,
}) => {
  const { openModal } = useContext(ModalContext);
  return (
    <>
      <p className={styles.heading}>{OUTPUT_NAV_NAME[navListGroup.key]}で絞り込む</p>
      <div className={styles.listOuter}>
        <ul className={styles.list}>
          {navListGroup.value.map((navList) => {
            const labelName =
              navListGroup.key === "station"
                ? `${navList[`${navListGroup.key}_name`]}駅`
                : navList[`${navListGroup.key}_name`];
            return (
              <li key={navList.id}>
                <a
                  href={navList.search_path}
                  className={styles.button}
                  data-ga-action={gaAction}
                  data-ga-label={labelName}
                >
                  {labelName}
                  {navList.is_number_displayed && (
                    <span className={styles.totalNum}>({navList.number})</span>
                  )}
                </a>
              </li>
            );
          })}
          {moreSearchButtonDisplayed && (
            <li>
              <button
                data-ga-action={gaAction}
                data-ga-label={`${OUTPUT_NAV_NAME[navListGroup.key]}_他`}
                className={styles.button}
                onClick={() => openModal(navListGroup.key)}
                type="button"
              >
                他＋
              </button>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};
